webpackJsonp([64592905802212],{

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ProvidenceImageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _HeroSmall = __webpack_require__(8);
	
	var _HeroSmall2 = _interopRequireDefault(_HeroSmall);
	
	var _LocationMicroNav = __webpack_require__(10);
	
	var _LocationMicroNav2 = _interopRequireDefault(_LocationMicroNav);
	
	var _LocationContent = __webpack_require__(9);
	
	var _LocationContent2 = _interopRequireDefault(_LocationContent);
	
	var _LocationRelated = __webpack_require__(11);
	
	var _LocationRelated2 = _interopRequireDefault(_LocationRelated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProvidenceLocation = function (_React$Component) {
	  _inherits(ProvidenceLocation, _React$Component);
	
	  function ProvidenceLocation() {
	    _classCallCheck(this, ProvidenceLocation);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ProvidenceLocation.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_HeroSmall2.default, { location: 'Providence, RI' }),
	      _react2.default.createElement(_LocationMicroNav2.default, null),
	      _react2.default.createElement(_LocationContent2.default, {
	        category: 'PlacesForBikes',
	        title: 'BIKE in PVD',
	        story: 'Providence\'s most recent bike plan includes City Walk, a four-mile corridor that will run through downtown to Roger Williams Park, linking some major long-distance recreational trails. The state tore down a section of I-95 through the heart of downtown a few years ago, leaving big open fields that are being redeveloped, with plans to include a good bike facility. Providence has a hard-working crew of bike advocates, some great city staffers and a mayor who is really excited about biking.'
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        title: 'Providence',
	        alt: 'City Walk in Providence',
	        sizes: this.props.data.providenceImage.sizes
	      }),
	      _react2.default.createElement(_LocationRelated2.default, {
	        prevLocationName: 'Colorado',
	        prevLocationPath: 'colorado',
	        prevLocationImgPath: this.props.data.providencePrevImage,
	        nextLocationName: 'California',
	        nextLocationPath: 'california',
	        nextLocationImgPath: this.props.data.providenceNextImage
	      })
	    );
	  };
	
	  return ProvidenceLocation;
	}(_react2.default.Component);
	
	exports.default = ProvidenceLocation;
	
	// GraphQL query
	
	var ProvidenceImageQuery = exports.ProvidenceImageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-providence-js-9f880ea51a79dd09bbc8.js